import type { BadgeColor } from '@/components/ui/catalyst/badge';
import type { ExternalTaskStatus } from '@/services/api/generated/externalTaskService';

export interface ExternalTaskStatusOption {
  id: ExternalTaskStatus;
  name: string;
}

/**
 * Static list of external task statuses for filter options.
 * Uses human-readable labels for better UX.
 */
export const EXTERNAL_TASK_STATUSES: ExternalTaskStatusOption[] = [
  { id: 'PENDING', name: 'Pending' },
  { id: 'IN_PROGRESS', name: 'In Progress' },
  { id: 'COMPLETED', name: 'Completed' },
  { id: 'NOT_APPLICABLE', name: 'Not Applicable' },
];

/**
 * Color mapping for external task status badges.
 */
export const EXTERNAL_TASK_STATUS_COLORS: Record<
  ExternalTaskStatus,
  BadgeColor
> = {
  PENDING: 'yellow',
  IN_PROGRESS: 'blue',
  COMPLETED: 'green',
  NOT_APPLICABLE: 'zinc',
};
